import { BreadcrumbList } from '@/components/Breadcrumbs/BreadcrumbList';
import { BreadcrumbItem } from '@/components/Breadcrumbs/BreadcrumbItem';
import { PageHeader } from '@/components/Header/Page/PageHeader';
import { useParams } from 'react-router-dom';
import Loader from '@/components/Loading/Loader';
import { NotFound } from '@/components/Message/NotFound';
import Card from '@/components/Card';
import { useGetEmailById } from '@/hooks/vehicule-check-email.hooks';
import { getFormattedDate, getFormattedTime } from '@/utils/date.utils';
import { FormField } from '@/components/Form/FormField';
import { FormFieldReportSection } from '@/components/Form/FormFieldReportSection';

export const ViewVehiculeCheckEmailPage = () => {
  const { id } = useParams();
  const { data, isLoading } = useGetEmailById(`${id}`);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <PageHeader
        backToLink={`/vehicule-check-request/${data?.data?.vehiculeCheckId}#emailsSent`}
        title="L'email"
        headingElement={
          <BreadcrumbList>
            <BreadcrumbItem
              text="Liste des emails"
              linkTo={`/vehicule-check-request/${data?.data?.vehiculeCheckId}#emailsSent`}
            />
            <BreadcrumbItem text="Email" active />
          </BreadcrumbList>
        }
      />
      {!data?.data ? (
        <NotFound text="Cet email n'existe pas ..." />
      ) : (
        <Card title="Email" bodyClassName="py-8 flex flex-col gap-5">
          <>
            <FormFieldReportSection>
              <FormField
                text="Date d'envoi :"
                containerClassName="items-center gap-2 max-sm:gap-0"
                textOuterWrapperClassName="w-auto"
                textClassName="font-semibold text-md text-black"
              >
                <div className="flex flex-1 flex-wrap items-start gap-5">
                  <p className="text-sm text-black">
                    {getFormattedDate(data?.data?.createdAt)} -{' '}
                    {getFormattedTime(data?.data?.createdAt)}
                  </p>
                </div>
              </FormField>
              <FormField
                text="De :"
                containerClassName="items-center gap-2 max-sm:gap-0"
                textOuterWrapperClassName="w-auto"
                textClassName="font-semibold text-md text-black"
              >
                <div className="flex flex-1 flex-wrap items-start gap-5">
                  <p className="text-sm text-black">
                    {data?.data?.fromName} {`<${data?.data?.fromEmail}>`}
                  </p>
                </div>
              </FormField>
              <FormField
                text="Reply-To :"
                containerClassName="items-center gap-2 max-sm:gap-0"
                textOuterWrapperClassName="w-auto"
                textClassName="font-semibold text-md text-black"
              >
                <div className="flex flex-1 flex-wrap items-start gap-5">
                  <p className="text-sm text-black">
                    {data?.data?.replyToEmail || '--'}
                  </p>
                </div>
              </FormField>
              <FormField
                text="À :"
                containerClassName="items-center gap-2 max-sm:gap-0"
                textOuterWrapperClassName="w-auto"
                textClassName="font-semibold text-md text-black"
              >
                <div className="flex flex-1 flex-wrap items-start gap-5">
                  <p className="text-sm text-black">
                    {data?.data?.toFirstname || '--'}{' '}
                    {data?.data?.toLastname || '--'}{' '}
                    {`<${data?.data?.toEmail || '--'}>`}
                  </p>
                </div>
              </FormField>
              {data?.data?.ccEmails?.length > 0 && (
                <FormField
                  text="Cc :"
                  containerClassName="items-center gap-2 max-sm:gap-0"
                  textOuterWrapperClassName="w-auto"
                  textClassName="font-semibold text-md text-black"
                >
                  <div className="flex flex-1 flex-wrap items-start gap-5">
                    <p className="text-sm text-black">
                      {data?.data?.ccEmails?.join(', ')}
                    </p>
                  </div>
                </FormField>
              )}
              <FormField
                text="Objet :"
                containerClassName="items-center gap-2 max-sm:gap-0"
                textOuterWrapperClassName="w-auto"
                textClassName="font-semibold text-md text-black"
              >
                <div className="flex flex-1 flex-wrap items-start gap-5">
                  <p className="text-sm font-semibold text-black">
                    {data?.data?.emailSubject}
                  </p>
                </div>
              </FormField>
            </FormFieldReportSection>
            <iframe
              srcDoc={data?.data?.emailContent}
              title="Email content"
              className="w-full border rounded"
              style={{ minHeight: 500 }}
              sandbox=""
            />
          </>
        </Card>
      )}
    </>
  );
};
